import { useMutation, UseMutationResult } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../../../services/queryClient";

export const useUpdateDisplayPicture = () => {
  const token = localStorage.getItem("W2ST_TUTOR_TOKEN");

  return useMutation(
    (profilePicture: string) =>
      axiosInstance
        .patch(
          "tutors/profile-picture",
          { profilePicture: profilePicture },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => res.data),
    {
      onSuccess: async () => {
        message.success("Profile picture updated");
        queryClient.invalidateQueries("gettutor");
      },
      onError: (error: any) => {
        message.error(
          error?.response?.data?.message || "Failed... Please try again."
        );
      },
    }
  );
};
